import { Cake, CakeSlice, Candy, IceCream, Cookie, Croissant, Utensils, PartyPopper, Popcorn, Coffee, GlassWater, Sparkles } from "lucide-react";

const MAP = { Cake, CakeSlice, Candy, IceCream, Cookie, Croissant, Utensils, PartyPopper, Popcorn, Coffee, GlassWater };

export const categoryIcon = (name) => MAP[name] || Sparkles;
